import React from 'react';
import PropTypes from 'prop-types';

const HomePageExhibitionListItem = (props) => {
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];

    function dateRange(start, end) {
        const startDay = start.getDate();
        const endDay = end.getDate();
        const startMonth = monthNames[start.getMonth()];
        const endMonth = monthNames[end.getMonth()];
        const startYear = start.getFullYear() % 1000;
        const endYear = end.getFullYear() % 1000;

        if (startYear !== endYear && startMonth !== endMonth && startDay !== endDay) {
            return startDay + " " + startMonth + " '" + startYear + " - " + endDay + " " + endMonth + " '" + endYear;
        }
        else if (startMonth !== endMonth && startDay !== endDay) {
            return startDay + " " + startMonth + " - " + endDay + " " + endMonth + " '" + endYear;
        }
        else if (startDay !== endDay) {
            return startDay + " - " + endDay + " " + endMonth + " '" + endYear;
        }
        else {
            return startDay + " " + startMonth + " '" + startYear;
        }
    }

    return (
        <li className="exhibition">
            <a className="name" href={props.url} target="_blank">{props.name}</a>
            <span className="details"><strong>{dateRange(props.startDate, props.endDate)}</strong> - {props.location}</span>
        </li>
    );
};

HomePageExhibitionListItem.propTypes = {
    name: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    location: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default HomePageExhibitionListItem;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageExhibitionListItem.js